import { addDays } from 'date-fns'
import { ICalendarDimensions } from '../containers/BookingCalendar/Calendar/Calendar'
import { ISummary } from '../models/Object'
import theme from '../theme/theme'
import { ISummaryResult } from '../utils/SummaryFiltering/reduceForSummary'

export default (
  ctx: CanvasRenderingContext2D,
  constants: ICalendarDimensions,
  cWidth: number,
  summary: { [key: number]: ISummaryResult },
  dateStart: Date,
  summarySettings: ISummary,
  summaryIconsBuffer: HTMLCanvasElement | null,
) => {
  const daysShownCount = Math.ceil(cWidth / constants.GRID_WIDTH)
  const iconsCount =
    +summarySettings.feeding +
    +summarySettings.fulfillment +
    +summarySettings.checkinout * 2
  const y = Math.round(
    (constants.SUMMARY_HEIGHT - iconsCount * constants.SUMMARY_ICON_SIZE) / 2,
  )
  ctx.font = `400 ${constants.SUMMARY_FONT_SIZE}px Montserrat`
  ctx.textBaseline = 'top'
  ctx.textAlign = 'left'

  for (let i = 0; i < daysShownCount; i++) {
    const x = i * constants.GRID_WIDTH
    ctx.fillStyle = theme.colors.palette.white
    ctx.fillRect(x, 0, constants.GRID_WIDTH, constants.SUMMARY_HEIGHT)
    ctx.fillStyle = theme.colors.calendar.gridBorder
    ctx.fillRect(x, 0, constants.GRID_BORDER_WIDTH, constants.SUMMARY_HEIGHT)
    if (summaryIconsBuffer) {
      ctx.drawImage(summaryIconsBuffer, x, 0)
    }
    let textY = y
    const textX = x + constants.GRID_WIDTH / 2 + constants.GRID_BORDER_WIDTH * 5
    const dateShown = addDays(dateStart, i)
    const daySummary = summary[+dateShown]

    ctx.fillStyle = 'rgb(0,0,0)'
    if (summarySettings.fulfillment) {
      ctx.fillText(daySummary ? `${daySummary.persons}` : '0', textX, textY)
      textY += constants.SUMMARY_ICON_SIZE
    }
    if (summarySettings.feeding) {
      ctx.fillText(daySummary ? `${daySummary.boarding}` : '0', textX, textY)
      textY += constants.SUMMARY_ICON_SIZE
    }
    if (summarySettings.checkinout) {
      ctx.fillText(daySummary ? `${daySummary.checkIns}` : '0', textX, textY)
      textY += constants.SUMMARY_ICON_SIZE
      ctx.fillText(daySummary ? `${daySummary.checkOuts}` : '0', textX, textY)
    }
  }

  ctx.fillStyle = theme.colors.calendar.gridBorder
  ctx.fillRect(0, 0, cWidth, constants.GRID_BORDER_WIDTH)
}
